<template>

    <div id="wx_qrcode">
        <h1>请扫码登录</h1>

    </div>
</template>

<script>
    import wxConfig from "../api/wxconfig";

    let globalId = '';
    export default {
        data() {
            return {
                headImage: {
                    picture: ''

                }
            }
        },
        methods: {},
        created() {
        }, mounted() {
            window.WwLogin({
                "id" : "wx_qrcode",
                "appid" : "ww61845d6b2e7a4ad2",
                "agentid" : "1000020",
                "redirect_uri" : "http%3A%2F%2Fworkplace.sinosoftweixin.com%25252Fworkplace",
                "state" : "",
                "href" : "",
            });
        }, destroyed() {

        }
    }


</script>

<style>
    .impowerBox .qrcode {width: 200px;}
    .impowerBox .title {display: none;}
    .impowerBox .info {width: 200px;}
    .status_icon {display: none  !important}
    .impowerBox .status {text-align: center;}
</style>
